<template>
    <div>
        <div class="white-box md:mb-5">
            <transition
                name="opacity"
                mode="out-in"
            >
                <Skeletons v-if="isGettingData" />
                <div v-else>
                    <h4 class="text-error mb-2.5 font-normal">
                        {{ isApply==='1'?'您目前保單狀態為保費緩繳中':'目前保單尚未申請保費緩繳' }}
                    </h4>
                    <div class="border-t border-gray-100 text-base mb-7 py-4 md:py-5">
                        <h4 class="text-secondary mb-2.5 font-bold">
                            請選擇欲變更之內容
                        </h4>
                        <Radio
                            v-model:checkedValue="selected"
                            value="1"
                            :disabled="isApply==='1'"
                            text="申請保費緩繳"
                            class="mb-2.5 items-baseline"
                        />
                        <Radio
                            v-model:checkedValue="selected"
                            value="0"
                            :disabled="isApply==='0'"
                            text="終止保費緩繳 (需補收當期尚未繳納之計畫保費)"
                            class="mb-2.5 items-baseline"
                        />
                    </div>
                </div>
            </transition>
        </div>
        <Bottombar>
            <template #right>
                <ButtonNextService
                    v-model:isSubmitOk="isSubmitOk"
                    :disabled="selected===isApply || isGettingData"
                    @click="saveAndgoNext"
                />
            </template>
        </Bottombar>
        <Loading :isLoading="isLoading" />
    </div>
</template>

<script>
import { ref, computed } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { getInfoA2, submitA2 } from '@/apis/A2';
import Bottombar from '@/components/layout/Bottombar.vue';
import ButtonNextService from '@/components/buttons/ButtonNextService.vue';
import Loading from '@/components/Loading.vue';
import Radio from '@/components/radios/Radio.vue';
import Skeletons from './Skeletons.vue';
import _ from 'lodash';

export default {
    components: {
        Bottombar,
        Loading,
        Radio,
        ButtonNextService,
        Skeletons,
    },
    setup() {
        const route = useRoute();
        const { code } = route.meta;
        const store = useStore();
        const isGetButtonInfo = ref(false);
        const isGettingData = ref(false);
        const isApply = ref(true);
        const isSubmitOk = ref(false);
        const isLoading = ref(false);
        const selected = ref(false);

        const result = computed(() => {
            const vuexData = store.state.services.changeItemsResult[code];
            return vuexData ? _.cloneDeep(vuexData) : undefined;
        });

        // 取得api資料
        const getData = () => {
            isGettingData.value = true;
            getInfoA2().then((res) => {
                isApply.value = res.data.defer ? '1' : '0';
                selected.value = res.data.defer ? '1' : '0';
                isGettingData.value = false;
            });
        };
        if (!result.value) {
            getData();
        } else {
            const { selectVal, storeIsApply } = result.value;
            isApply.value = storeIsApply;
            selected.value = selectVal;
        }

        const saveAndgoNext = () => {
            isLoading.value = true;
            submitA2(selected.value === '1').then(() => {
                isSubmitOk.value = true;
                const value = {
                    storeIsApply: isApply.value,
                    selectVal: selected.value,
                };
                store.dispatch('services/setChangeItemsResult', { code, value });
            }).finally(() => {
                isLoading.value = false;
            });
        };

        return {
            selected,
            isApply,
            isGetButtonInfo,
            isLoading,
            isGettingData,
            saveAndgoNext,
            isSubmitOk
        };
    },
};
</script>
